import React from "react";
import { resolveLogo } from "@/context/AppContext";

export const ToothMark = ({ size = 24, className = "dm-accent-text" }) => (
  <svg viewBox="0 0 64 72" width={size} height={size} className={className} fill="none" aria-hidden="true">
    <path
      d="M32 4C22 4 18 8 12 8 5.5 8 2 13.5 2 22c0 10 4 14 6.5 24C10.6 54.6 12 68 17.5 68c5 0 6-10 8-16 1.6-4.8 4.9-4.8 6.5 0 2 6 3 16 8 16 5.5 0 6.9-13.4 9-22 2.5-10 6.5-14 6.5-24C55.5 13.5 52 8 45.5 8 40 8 42 4 32 4Z"
      stroke="currentColor"
      strokeWidth="4.2"
      strokeLinejoin="round"
    />
    <path
      d="M15.5 8c-2-4.4 2.4-8 6.8-6c3.6 1.6 3 6.4-1 6.8"
      stroke="currentColor"
      strokeWidth="2.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <g stroke="currentColor" strokeWidth="3.4" strokeLinecap="round">
      <path d="M17 27h20" />
      <path d="M15 35h22" />
      <path d="M17 43h14" />
    </g>
  </svg>
);

export const ClinicMark = ({ logo, size = 40, className = "" }) => {
  const src = resolveLogo(logo);
  return (
    <span
      className={`grid shrink-0 place-items-center overflow-hidden rounded-xl border border-slate-200 bg-white ${className}`}
      style={{ width: size, height: size }}
    >
      {src ? (
        <img src={src} alt="" className="h-full w-full object-cover" />
      ) : (
        <ToothMark size={size * 0.56} />
      )}
    </span>
  );
};

export const Brand = ({ tagline = false, size = "md" }) => {
  const big = size === "lg";
  return (
    <div className="flex flex-col items-start">
      <img src="/dentmemo-logo-transparent.png" alt="DentMemo" className={big ? "h-12 w-auto" : "h-9 w-auto"} />
      {tagline && <span className={`block text-slate-500 ${big ? "mt-2.5 text-sm" : "mt-1.5 text-xs"}`}>Second brain for dentists.</span>}
    </div>
  );
};
